export default "__VITE_ASSET__BOVphm1q__"